import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { FeatureFlag } from '@/_shared/constants/featureFlags';
import { useFeatureFlags } from '@/_shared/hooks/useFeatureFlag';
import { TutorialDialog } from '../TutorialDialog';

export const FirstTutorial: FC = () => {
  const t = useTranslations('tutorial.slides');

  const { isFeatureEnabled } = useFeatureFlags();
  const isChatBotEnabled = isFeatureEnabled(FeatureFlag.CHATBOT);

  const slides = [
    {
      title: t('slide1.title'),
      description: t('slide1.description'),
      assetName: 'tutorialFirstTutorialSlide1',
    },
    {
      title: t('slide2.title'),
      description: t('slide2.description'),
      assetName: 'tutorialFirstTutorialSlide2',
    },
    {
      title: t('slide3.title'),
      description: t('slide3.description'),
      assetName: 'tutorialFirstTutorialSlide3',
    },
    {
      title: t('slide4.title'),
      description: t('slide4.description'),
      assetName: 'tutorialFirstTutorialSlide4',
    },
  ];

  return (
    <TutorialDialog
      translationsKey='tutorial'
      dialogKey='firstTutorial'
      slides={isChatBotEnabled ? slides : slides.slice(0, 3)}
    />
  );
};
